module.exports = __webpack_public_path__ + "files/logo_tu_liberec.svg";